import { AppEnum, AppStage } from '@enums/app.enum';

export abstract class AppEnvVariables {
  public static isProd = (): boolean => AppEnum.StageEnv === AppStage.PROD;

  public static isDev = (): boolean => AppEnum.StageEnv === AppStage.DEV;

  public static isStage = (): boolean => AppEnum.StageEnv === AppStage.STAGE;

  public static getCustomerDashboardUrl = (): string => {
    if (this.isProd()) {
      return 'https://merchant.rixsus.com';
    }

    if (this.isStage()) {
      return 'https://merchant-stg.rixsus.com';
    }

    return 'https://merchant-dev.rixsus.com';
  };
}
